import { render, staticRenderFns } from "./VDraftSnackbar.vue?vue&type=template&id=7a0ed37a"
import script from "./VDraftSnackbar.vue?vue&type=script&lang=js"
export * from "./VDraftSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports